// sagas.js
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from "../actions/provinceTypes.js";
import * as actions from "../actions/provinceActions.js";
import axiosInstance from '../../interceptor/interceptor.js';  


// Worker Saga: Will fetch province types from API
function* fetchProvinceTypesSaga() {
    try {
        const response = yield call(axiosInstance.get, '/auth/provinces');
        ////console.log(response.data);
        yield put(actions.fetchProvinceTypesSuccess(response.data.provinces));
    } catch (error) {
        yield put(actions.fetchProvinceTypesFailure(error.message));
    }
}




// Watch for the FETCH_EMPLOYEE_TYPES_REQUEST action and trigger the fetchEmployeeTypesSaga
export default function* watchFetchData() {
    yield takeLatest(types.FETCH_PROVINCE_TYPES_REQUEST,fetchProvinceTypesSaga);
}

